import { AppBar, Toolbar, Typography } from '@mui/material';

import { IBusiness } from '../../models/api/entities';
import Grid from '@mui/material/Grid';

interface Props {
    business: IBusiness;
}

const Header = ({ business }: Props) => (
    <>
        <AppBar position="static" color="transparent" sx={{ bgcolor: 'black' }}>
            {business.id === '61545d154b317e4fccf33651' && (
                <Toolbar>
                    <img src="https://bookpad.blob.core.windows.net/assets/suwanmali-logo-alt.png" alt="logo" width={45} height={45} />
                </Toolbar>
            )}

            <Grid container justifyContent="center">
                <Typography variant="h2" fontWeight={400} align="center" sx={{ color: 'white', width: 150 }}>
                    {business.name}
                </Typography>
            </Grid>
        </AppBar>
    </>
);

export default Header;
